module.exports = __webpack_public_path__ + "step-rolling.a137e7e36fc6c412b05b522fb2a7bef2.hashedasset.svg";